module.exports = __webpack_public_path__ + "static/img/partner-logo2.a64d9ed8.jpg";